import RoleForm from "@components/forms/RoleForm/RoleForm";
import Spacing from "@vfuk/core-spacing/";
import Container from "@vfuk/core-container";
import DashShell from "@components/common/DashShell";
import { useEffect, useCallback } from "react";
import { useRoleManagementStore } from "src/hooks/stores";
import { SpinnerLoader, NoResultsRow, Crumbs } from "@ucchub/ui";
import Button from "@vfuk/core-button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import breadCrumbs from "@json/common/crumbs.json";
import "./AddRole.css";

const AddRole = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const {
    loading: roleLoading,
    error: roleFetchError,
    call: fetchRole,
  } = useRoleManagementStore((state) => state.fetchRole);
  const role = useRoleManagementStore((state) => state.role);
  const actionButtonPermission = useRoleManagementStore(
    (state) => state.fetchRole.roleActions
  );

  const loadRole = useCallback(() => {
    fetchRole("own-permissions"); //This will fetch the current user role permissions
  }, [fetchRole]);

  useEffect(() => {
    loadRole();
  }, [loadRole]);

  return (
    <DashShell>
      <Crumbs items={breadCrumbs.add_Roles} />

      <div data-testid="addRole">
        <Container appearance="secondary" paddingLevel={6}>
          {!roleLoading && Object.keys(role).length !== 0 && (
            <RoleForm
              role="add"
              result={role}
              permissionOnActionButton={actionButtonPermission}
            />
          )}
          {roleLoading && (
            <SpinnerLoader
              srText={t("core:roles:loading") || "Loading..."}
              text={t("core:roles:loading") || "Loading..."}
            />
          )}
          {roleFetchError !== undefined &&
            roleFetchError !== "" &&
            !roleLoading && (
              <>
                <NoResultsRow text={roleFetchError} />
                <Spacing
                  spacingLevel={{
                    top: 3,
                  }}
                >
                  <Button
                    width="full"
                    text={t("core:roles:back")}
                    appearance="alt1"
                    onClick={() => navigate("/users")}
                  />
                </Spacing>
              </>
            )}
        </Container>
      </div>
    </DashShell>
  );
};

export default AddRole;
